import React from "react";
import { popupMenuOptions } from "../parent/data/popupMenuOptions";

export const TravelExemptionModalContent = (props) => {
  const advance = (method) => {
    props.travelReasonSelected(method);
    props.hideModal();
  };

  return (
    <div>
      <div className="f24 bold">Choose Reason for Travel Exemption</div>
      <div>
        Any travel within the country does <span>NOT</span> require a travel exemption.
      </div>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance("TravelAbroad");
        }}
        data-e2e-id="travelAbroad"
      >
        Traveling Outside of the Country
      </button>
      <button
        className="px-1 w-100 modal-button"
        style={{ color: "#00558c", borderColor: "#00558c" }}
        onClick={() => {
          advance("ForeignPurchase");
        }}
        data-e2e-id="foreignPurchase"
      >
        Online Purchase from Foreign Country
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/modal/travel-exemption-modal-content.component.js